import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-spectacle-home',
  templateUrl: './spectacle-home.component.html',
  styleUrls: ['./spectacle-home.component.css']
})
export class SpectacleHomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
